import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addTimeWindowsLabel: translate({
      id: 'ui.timeWindow.addTimeWindowsLabel',
    }),
    addTimeWindowTooltip: translate({ id: 'order.form.bulk.timeWindows.addTimeWindowTooltip' }),

    addTimeWindowDisabledTooltip: translate({
      id: 'order.form.bulk.timeWindows.addTimeWindowDisabledTooltip',
    }),
  }))

  return api
}
